/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { empty, errorResponse, isObject, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";

// api
import feesApi from "../../api/Fees";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";
import InputField from "../../components/form/InputField";
import { AuthContext } from "../Root/ProtectedRoute";
import SelectField from "../../components/form/SelectField";
import { Editor } from "primereact/editor";
import Header4 from "../../components/headers/Header4";
import colors from "../../config/colors";
import FeeWrapper from "../../components/appWrapper/FeeWrapper";

// data
import { yesNo } from "../../data/yesNo";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  title: Yup.string().required(required),
  fee_category_description: Yup.string().optional(),
  active: Yup.string().required(required)
});

const AddUpdateFeeCategory = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [initialValues, setInitialValues] = useState({
    title: "",
    fee_category_description: '',
    active: '',
  });

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { feeCategoryId } = useParams();
  const toastTR = useRef(null);
  const [feeCategoryDescription, setFeeCategoryDescription] = useState('');

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (feeCategoryId) {
      getFeeCategory();
    }
  }, []);

  /**
   * Get activity details
   * @returns 
   */
  const getFeeCategory = async () => {
    setIsLoading(true);
    try {
      const response = await feesApi.getFeeCategory(feeCategoryId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to get fee category details."
        );
      }

      if (isObject(response_data?.response) && !empty(response_data?.response)) {
        const { title, active, feeCategoryDescription } = response_data.response;
        setFeeCategoryDescription(feeCategoryDescription);
        return setInitialValues((prev) => ({ ...prev, title, active }));
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle submission
   * @param values
   */
  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      if (empty(values)) {
        return responseDialog(
          "error",
          "Error Alert",
          "Something went wrong! Try again later."
        );
      }

      values.fee_category_description = feeCategoryDescription; 
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";

      let response;
      let feeCategoryAdded = false;
      let feeCategoryUpdated = false;
      if (!feeCategoryId) {
        response = await feesApi.addFeeCategory(schoolId, values);
        feeCategoryAdded = true;
      } else {
        response = await feesApi.updateFeeCategory(
          schoolId,
          feeCategoryId,
          values
        );
        feeCategoryUpdated = true;
      }
      const response_data = prepareResponseData(response);
      if (!response_data?.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }

      navigate("/fees/fee-categories", {
        state: { feeCategoryAdded, feeCategoryUpdated },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <FeeWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title={
                !empty(feeCategoryId)
                  ? "Update Fee Category"
                  : "Add Fee Category"
              }
            />
            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
              {({ values, setFieldValue, handleChange }) => (
                <Form style={{ width: "100%" }}>
                  <div className="app_input_group">
                    <InputField
                      placeholder="Enter Fee Type Title E.g School Fees, Portal Levy etc."
                      name="title"
                      height={50}
                      labelTitle="Title"
                      required={true}
                      />
                    </div>
                  <Header4>
                    <span className="fs-16">
                      Description (Optional)
                    </span>
                  </Header4>
                  <div style={{ width: '100%' }}>
                    <Editor value={feeCategoryDescription} onTextChange={(e) => setFeeCategoryDescription(e.htmlValue)} style={{ height: '320px', backgroundColor: colors.white }} />
                  </div>
                  <div className="app_input_group">
                    <SelectField
                      labelTitle="Active"
                      required={true}
                      placeholder="Select Active"
                      name="active"
                      options={yesNo}
                      height={50}
                      valueKey="title"
                      containerWidth={300}
                      selectedOption={values.active}
                      handleChangeFunc={handleChange}
                      />
                  </div>
                  
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonIcon
                      height={45}
                      marginTop={5}
                      color="#ffffff"
                      backgroundColor="#633ccd"
                      width={300}
                      borderColor="#633ccd"
                      buttonText={
                        feeCategoryId ? "Update Fee Category" : "Add Fee Category"
                      }
                      type="submit"
                    />
                  </div>
                </Form>
              )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </FeeWrapper>
    </>
  );
};

export default AddUpdateFeeCategory;
